// extracted by mini-css-extract-plugin
export default {"primaryColor":"#0f141a","primaryTextColor":"#15104d","secondaryTextColor":"#7d8fb3"};